import { BuildHtml } from "~/components/BuildHtml";
import {
  ResponsiveArticleCard,
  ResponsiveArticleCardProps,
} from "~/components/ResponsiveArticleCard";
import { TagToClassNameMap } from "~/lib/shared/html-utils";
import { Body, Headline, Link } from "~/ui-library";

export interface SeriesIntroductionCardProps
  extends Omit<ResponsiveArticleCardProps, "children"> {
  introductionContentHTML: string;
  introductionTitle: string;
  additionalStories: {
    additionalStoryTitle: string | null;
    additionalStoryLink: string | null;
  }[];
}

const tagToClassNameMap: TagToClassNameMap = new Map([
  ["p", "mb-m last:mb-0 body-regular"],
  ["h1", "mb-m"],
  ["h2", "mb-m"],
  ["h3", "mb-m"],
]);

export const SeriesIntroductionCard = ({
  introductionContentHTML,
  introductionTitle,
  additionalStories,
  ...props
}: SeriesIntroductionCardProps): JSX.Element | null => (
  <ResponsiveArticleCard {...props}>
    {introductionTitle ? (
      <Headline level={6} blockCase>
        {introductionTitle}
      </Headline>
    ) : null}
    <Body className="mt-s">
      <BuildHtml
        html={introductionContentHTML}
        tagToClassNameMap={tagToClassNameMap}
      />
    </Body>
    {additionalStories?.length >= 1 ? (
      <>
        <Headline className="mt-m" level={6} blockCase>
          Also in this series
        </Headline>
        {additionalStories.map((story, idx) =>
          story.additionalStoryTitle && story.additionalStoryLink ? (
            <Link
              className="mt-xs !block"
              href={story.additionalStoryLink}
              key={idx}
            >
              <Body bold>{story.additionalStoryTitle}</Body>
            </Link>
          ) : null
        )}
      </>
    ) : null}
  </ResponsiveArticleCard>
);
